import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import { BindAPI, BindPostAPI } from "../services/APIConnection";
import { ClientProfileMEReportHeader } from "../components/HeaderAttribute";
import * as XLSX from "sheetjs-style";
import jsPDF from "jspdf";
import "jspdf-autotable";
import fpaiLogo from "../image/FPAILogo.jpg";
import MultiSelect from "../ReusableComponents/MultiSelect";
import ReportRowRowPage from "../components/ReportGridRowPage";
import { useUserCapability } from "../components/ConstantReducerProvider";
import { IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
import Loader from "../ReusableComponents/Loader";
const ClientProfileMEReport = () => {
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const [branchProject, setBranchProject] = useState("");
  const [branchName, setBranchName] = useState("");
  const [sdp, setSDP] = useState("");
  const [branchProjectError, setBranchProjectError] = useState("");
  const [sdpError, setSDPError] = useState("");
  const [area, setArea] = useState("");
  const [areaError, setAreaError] = useState("");
  const [bindBranchProjectDD, setBindBranchProjectDD] = useState([]);
  const [bindClientProfileMEData, setBindClientProfileMEData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [getSDPDatas, setGetSDPDatas] = useState([]);
  const [bindSDP, setBindSDP] = useState([]);

  const [getAreaDatas, setGetAreaDatas] = useState([]);
  const [bindArea, setBindAreaDD] = useState([]);
  const [isLoading, setIsLoading] = useState(false);


  const [branchProjectNamesList, setBranchProjectNamesList] = useState([]);
  const [sdpNamesList, setSDPNamesList] = useState([]);
  const [areaNamesList, setAreaNamesList] = useState([]);

  useEffect(
    () => {
      if (branchProject) {
        try {
          const getSelectedSDP = async () => {
            const userProfileDatas = userProfileState.userProfile;
            const [profile] = userProfileDatas;
            const data = {
              mstOrganizationStructureId: profile.MstOrganizationId,
              mstBranchId: profile.MstLocationId,
              mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
              mstUserId: profile.MstUserId,
              mstRoleId: profile.MstRoleId,
              languageCode: "en",
            };


            const locationResponse = await BindPostAPI([data], "SDPAPI/GetSDP");

            setGetSDPDatas(locationResponse.data.Table);

            if (userProfileDatas && userProfileDatas[0]) {
              const sdpLabels = locationResponse.data.Table.filter((item) =>
                branchProject.includes(parseInt(item.MstLocationId))
              ).map((item) => ({
                MstSDPId: item.MstSDPId,
                SDP_en: item.SDP_en,
              }));

              const sdpSelected = sdpLabels.map((SD) => ({
                value: SD.MstSDPId,
                label: SD.SDP_en,
              }));

              if (
                userProfileDatas[0].MstOrganizationId == 1 ||
                userProfileDatas[0].MstOrganizationId == 2
              ) {
                setBindSDP(sdpSelected);
              } else {
                const allSDPIds = userProfileDatas[0]?.AllSDP;
                const sdpId = userProfileDatas[0]?.MstSDPId;

                if (allSDPIds && Array.isArray(allSDPIds)) {
                  const filteredSdpSelected = sdpSelected.filter((sdp) =>
                    allSDPIds.includes(sdp.value)
                  );
                  setBindSDP(filteredSdpSelected);
                }
                if (sdpId) {
                  setBindSDP([]);
                  const filteredSdpSelected = sdpSelected.filter((sdp) =>
                    Array.isArray(sdpId)
                      ? sdpId.includes(sdp.value)
                      : sdpId === sdp.value
                  );
                  setBindSDP(filteredSdpSelected);
                }
              }
            }
          };

          getSelectedSDP();
        } catch (e) {
        }
      }
    },
    [branchProject ? branchProject : undefined],
    userProfileDatas ? userProfileDatas : undefined
  );
  useEffect(() => {
    if (sdp) {
      try {
        const getSelectedArea = async () => {
          const userProfileDatas = userProfileState.userProfile;
          const [profile] = userProfileDatas;
          const data = {
            mstOrganizationStructureId: profile.MstOrganizationId,
            mstBranchId: profile.MstLocationId,
            mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
            mstUserId: profile.MstUserId,
            mstRoleId: profile.MstRoleId,
            languageCode: "en",
          };


          const locationResponse = await BindPostAPI([data], "AreaAPI/GetArea");
          setGetAreaDatas(locationResponse.data.Table);

          const areaLabels = locationResponse.data.Table.filter((item) =>
            sdp.includes(item.MstSDPId)
          ).map((item) => ({
            MstAreaId: item.MstAreaId,
            AreaName_en: item.AreaName_en,
          }));

          const areaSelected = areaLabels.map((AR) => ({
            value: AR.MstAreaId,
            label: AR.AreaName_en,
          }));

          setBindAreaDD(areaSelected);
        };

        getSelectedArea();
      } catch (e) {
      }
    }
  }, [sdp ? sdp : undefined]);

  useEffect(() => {
    if (
      userProfileDatas[0]?.MstOrganizationId == 2 ||
      userProfileDatas[0]?.MstOrganizationId == 3
    ) {
      if (userProfileDatas[0]?.MstSDPId == null) {
        setBranchName(userProfileDatas[0]?.LocationName_en);
        setBranchProject([userProfileDatas[0]?.MstLocationId]);
        setSDP("");
      } else {
        setBranchName(userProfileDatas[0]?.LocationName_en);
        setBranchProject([userProfileDatas[0]?.MstLocationId]);
        setSDP([userProfileDatas[0]?.MstSDPId]);
      }
    }
    BranchProjectFetchData();
  }, [userProfileDatas ? userProfileDatas : undefined]);

  const GoButton = async () => {

    setIsLoading(true);
    const branchProjectValidate = branchProject ? "" : "Select Branch/Project";
    setBranchProjectError(branchProjectValidate);

    const sdpValidate = sdp ? "" : "Select SDP";
    setSDPError(sdpValidate);

    const areaValidate = area ? "" : "Select Area";
    setAreaError(areaValidate);

    let branchArray = Array.from(
      { length: branchProject.length },
      (v, i) => branchProject[i]
    );
    let branchResult = branchArray.join(",");

    let sdpArray = Array.from({ length: sdp.length }, (v, i) => sdp[i]);
    let sdpResult = sdpArray.join(",");

    let areaArray = Array.from({ length: area.length }, (v, i) => area[i]);
    let areaResult = areaArray.join(",");

    if (!branchProjectValidate && !sdpValidate && !areaValidate) {
      const ReportData = [
        {
          mstBranchId: branchResult,
          mstSDPId: sdpResult,
          mstAreaId: areaResult,
          fromDate: fromDate,
          toDate: toDate,
        },
      ];
      const response = await BindPostAPI(
        ReportData,
        "ClientAPI/ReportClientProfileME"
      );
      const formattedData = response.data.Table.map((row) => ({
        ...row,

        TotalDisability:
          Number(row.CountMstClientIdDisability1 || 0) +

          Number(row.CountMstClientIdDisability2 || 0) +
          Number(row.CountMstClientIdDisability3 || 0) +
          Number(row.CountMstClientIdDisability4 || 0) +
          Number(row.CountMstClientIdDisability5 || 0) +
          Number(row.CountMstClientIdDisability6 || 0) +
          Number(row.CountMstClientIdDisability7 || 0),
      }));
      setBindClientProfileMEData(formattedData);
      setShowTable(true);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const automaticFromDate = `${currentYear}-01-01`;
    setFromDate(automaticFromDate);

    const formattedToDate = today.toISOString().split("T")[0];
    setToDate(formattedToDate);
  }, []);


  const exportData = (headers, rows) => {
    const wsData = [headers, ...rows.map(Object.values)];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    const borderStyle = {
      border: {
        top: { style: "thin", color: { rgb: "00000000" } },
        bottom: { style: "thin", color: { rgb: "00000000" } },
        left: { style: "thin", color: { rgb: "00000000" } },
        right: { style: "thin", color: { rgb: "00000000" } },
      },
    };

    headers.forEach((_, colIndex) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex });
      ws[cellAddress].s = {
        ...ws[cellAddress].s,
        ...borderStyle,
        fill: { fgColor: { rgb: "2D2D6E" } }, // Dark blue background color for header
        font: { bold: true, color: { rgb: "FFFFFF" } }, // White font color for header
      };
    });

    rows.forEach((_, rowIndex) => {
      headers.forEach((_, colIndex) => {
        const cellAddress = XLSX.utils.encode_cell({
          r: rowIndex + 1,
          c: colIndex,
        });
        ws[cellAddress].s = { ...ws[cellAddress].s, ...borderStyle };
      });
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, "Profile_ME.xlsx");
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
  };


  // const handleExport = async () => {
  //   const createdBy = sessionStorage.getItem("createdBy");

  //   /* -------------------- FILTER DATA -------------------- */

  //   const selectedOptionsData = {
  //     branchProjectData:
  //       branchProjectNamesList.length > 0
  //         ? branchProjectNamesList.toString()
  //         : branchName,
  //     sdpData: sdpNamesList.length > 0 ? sdpNamesList.toString() : "",
  //     areaData: areaNamesList.length > 0 ? areaNamesList.toString() : "",
  //   };

  //   try {
  //     /* -------------------- HEADERS -------------------- */

  //     const headers = [
  //       "Branch",
  //       "SDP",
  //       "Area",
  //       "Marginalized and Excluded",
  //       "Clients No.",
  //     ];

  //     /* -------------------- TOP ROWS -------------------- */

  //     const titleRow = ["Profile ME"];

  //     const dateRow = [
  //       "",
  //       "From Date:",
  //       formatDate(fromDate),
  //       "To Date:",
  //       formatDate(toDate),
  //     ];

  //     const branchRow = [
  //       "Branch/Project:",
  //       selectedOptionsData.branchProjectData,
  //       "",
  //       "S.D.P.: " + selectedOptionsData.sdpData,
  //       "Area: " + selectedOptionsData.areaData,
  //     ];

  //     const spacingRow = [""];

  //     /* -------------------- DATA -------------------- */

  //     const val = v => Number(v) || 0;
  //     const tableData = [];

  //     bindClientProfileMEData.forEach(r => {
  //       const base = [r.BranchName, r.SDP, r.Area];

  //       tableData.push(
  //         [...base, "Person living with disability", 0],
  //         [...base, "Visual", val(r.CountMstClientIdDisability1)],
  //         [...base, "Locomotor", val(r.CountMstClientIdDisability2)],
  //         [...base, "Hearing", val(r.CountMstClientIdDisability3)],
  //         [...base, "Speech", val(r.CountMstClientIdDisability4)],
  //         [...base, "Intellectual", val(r.CountMstClientIdDisability5)],
  //         [...base, "Multiple disability", val(r.CountMstClientIdDisability6)],
  //         [...base, "Not applicable", val(r.CountMstClientIdDisability7)],
  //         [...base, "Person living with disability (Total exclusive)", val(r.CountMstClientIdMEClientsId1)],
  //         [...base, "BPL cardholder (Yes)", val(r.TotalClientBPLCardholder)],
  //         [...base, "SC,ST,DT,NT", val(r.CountMstClientIdMEClientsId2)],
  //         [...base, "Adolescent (10-19)", val(r.TotalClientAge10to19)],
  //         [...base, "Young population (15-24)", val(r.TotalClientAge15to24)],
  //         [...base, "Sex worker", val(r.CountMstClientIdMEClientsId3)],
  //         [...base, "High risk Migrants", val(r.CountMstClientIdMEClientsId4)],
  //         [...base, "IDU's", val(r.CountMstClientIdMEClientsId5)],
  //         [...base, "PLHIV", val(r.CountMstClientIdMEClientsId6)],
  //         [...base, "Transman", val(r.CountMstClientIdMEClientsId7)],
  //         [...base, "Transwoman", val(r.CountMstClientIdMEClientsId8)],
  //         [...base, "Transgender", val(r.CountMstClientIdMEClientsId9)],
  //         [...base, "Lesbian", val(r.CountMstClientIdMEClientsId10)],
  //         [...base, "Gay", val(r.CountMstClientIdMEClientsId11)],
  //         [...base, "Bisexual", val(r.CountMstClientIdMEClientsId12)],
  //         [...base, "Intersex", val(r.CountMstClientIdMEClientsId13)],
  //         [...base, "Closed settings", val(r.CountMstClientIdMEClientsId14)],
  //         [...base, "Vulnerable Woman", val(r.CountMstClientIdMEClientsId15)],

  //       );

  //       tableData.push([
  //         r.BranchName,
  //         r.SDP,
  //         r.Area,
  //         "Total Marginalized and Excluded",
  //         val(r.TotalClient),
  //       ]);
  //     });

  //     /* -------------------- GRAND TOTAL -------------------- */

  //     const grandTotal = tableData.reduce(
  //       (sum, r) => sum + Number(r[4] || 0),
  //       0
  //     );

  //     tableData.push(["Total", "Total", "", "", grandTotal]);

  //     /* -------------------- SHEET DATA -------------------- */

  //     const wsData = [
  //       titleRow,
  //       dateRow,
  //       branchRow,
  //       spacingRow,
  //       headers,
  //       ...tableData,
  //     ];

  //     const ws = XLSX.utils.aoa_to_sheet(wsData);

  //     /* -------------------- MERGES -------------------- */

  //     // ws["!merges"] = [
  //     //   { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } },
  //     //   { s: { r: 1, c: 1 }, e: { r: 1, c: 2 } },
  //     //   { s: { r: 1, c: 3 }, e: { r: 1, c: 4 } },
  //     //   { s: { r: 2, c: 1 }, e: { r: 2, c: 2 } },
  //     // ];

  //     /* -------------------- HEADER STYLE -------------------- */

  //     headers.forEach((_, c) => {
  //       const cell = XLSX.utils.encode_cell({ r: 4, c });
  //       ws[cell].s = {
  //         font: { bold: true, color: { rgb: "FFFFFF" } },
  //         fill: { fgColor: { rgb: "2D2D6E" } },
  //         alignment: { horizontal: "center", vertical: "center" },
  //         border: {
  //           top: { style: "thin" },
  //           bottom: { style: "thin" },
  //           left: { style: "thin" },
  //           right: { style: "thin" },
  //         },
  //       };
  //     });

  //     /* -------------------- COLUMN WIDTHS -------------------- */

  //     ws["!cols"] = [
  //       { width: 20 },
  //       { width: 25 },
  //       { width: 30 },
  //       { width: 55 },
  //       { width: 15 },
  //     ];

  //     /* -------------------- BORDERS -------------------- */

  //     const range = XLSX.utils.decode_range(ws["!ref"]);
  //     for (let R = range.s.r; R <= range.e.r; R++) {
  //       for (let C = range.s.c; C <= range.e.c; C++) {
  //         const ref = XLSX.utils.encode_cell({ r: R, c: C });
  //         if (!ws[ref]) continue;

  //         ws[ref].s = {
  //           ...ws[ref].s,
  //           border: {
  //             top: { style: "thin" },
  //             bottom: { style: "thin" },
  //             left: { style: "thin" },
  //             right: { style: "thin" },
  //           },
  //         };
  //       }
  //     }

  //     /* -------------------- EXPORT -------------------- */

  //     const wb = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, "Profile ME");
  //     XLSX.writeFile(wb, "Profile ME.xlsx");

  //     /* -------------------- SUCCESS LOG -------------------- */

  //     await IUDAPI(
  //       {
  //         mstUserId: parseInt(createdBy, 10),
  //         sp: "PROFILE ME EXPORT",
  //         action: "EXCEL EXPORT",
  //         status: "SUCCESS",
  //         tableName: null,
  //         description: `Profile ME export successful | Records exported: ${bindClientProfileMEData.length}`
  //       },
  //       "Log/IUDLog"
  //     );

  //   } catch (error) {
  //     console.error(error);

  //     /* -------------------- ERROR LOG -------------------- */

  //     await IUDAPI(
  //       {
  //         mstUserId: parseInt(createdBy, 10),
  //         sp: "PROFILE ME EXPORT",
  //         action: "EXCEL EXPORT",
  //         status: "FAILED",
  //         tableName: null,
  //         description: error?.message || "Export failed",
  //       },
  //       "Log/IUDLog"
  //     );

  //     toast.error("Export failed", {
  //       position: "top-center",
  //       duration: 1500,
  //     });
  //   }
  // };

  const handleExport = async () => {
    const createdBy = sessionStorage.getItem("createdBy");

    /* -------------------- FILTER DATA -------------------- */

    const selectedOptionsData = {
      branchProjectData:
        branchProjectNamesList.length > 0
          ? branchProjectNamesList.toString()
          : branchName,
      sdpData: sdpNamesList.length > 0 ? sdpNamesList.toString() : "",
      areaData: areaNamesList.length > 0 ? areaNamesList.toString() : "",
    };

    try {
      /* -------------------- HEADERS -------------------- */

      const headers = [
        "Branch",
        "SDP",
        "Area",
        "Marginalized and Excluded",
        "Clients No.",
      ];

      /* -------------------- TOP ROWS -------------------- */

      const titleRow = ["Profile ME"];

      const dateRow = [
        "",
        "From Date:",
        formatDate(fromDate),
        "To Date:",
        formatDate(toDate),
      ];

      const branchRow = [
        "Branch/Project:",
        selectedOptionsData.branchProjectData,
        "",
        "S.D.P.: " + selectedOptionsData.sdpData,
        "Area: " + selectedOptionsData.areaData,
      ];

      const spacingRow = [""];

      /* -------------------- DATA -------------------- */

      const val = (v) => Number(v) || 0;
      const tableData = [];

      bindClientProfileMEData.forEach((r) => {
        const base = [r.BranchName, r.SDP, r.Area];

        // Calculate disability total from breakdown values
        const disabilityBreakdownTotal =
          val(r.CountMstClientIdDisability1) + // Visual
          val(r.CountMstClientIdDisability2) + // Locomotor
          val(r.CountMstClientIdDisability3) + // Hearing
          val(r.CountMstClientIdDisability4) + // Speech
          val(r.CountMstClientIdDisability5) + // Intellectual
          val(r.CountMstClientIdDisability6) + // Multiple disability
          val(r.CountMstClientIdDisability7); // Not applicable

        // Build disability breakdown rows
        tableData.push(
          [...base, "Person living with disability", val(r.CountMstClientIdMEClientsId1)],
          [...base, "Visual", val(r.CountMstClientIdDisability1)],
          [...base, "Locomotor", val(r.CountMstClientIdDisability2)],
          [...base, "Hearing", val(r.CountMstClientIdDisability3)],
          [...base, "Speech", val(r.CountMstClientIdDisability4)],
          [...base, "Intellectual", val(r.CountMstClientIdDisability5)],
          [...base, "Multiple disability", val(r.CountMstClientIdDisability6)],
          [...base, "Not applicable", val(r.CountMstClientIdDisability7)],
          [...base, "Person living with disability (Total exclusive)", disabilityBreakdownTotal],
          [...base, "BPL cardholder (Yes)", val(r.TotalClientBPLCardholder)],
          [...base, "SC,ST,DT,NT", val(r.CountMstClientIdMEClientsId2)],
          [...base, "Adolescent (10-19)", val(r.TotalClientAge10to19)],
          [...base, "Young population (15-24)", val(r.TotalClientAge15to24)],
          [...base, "Sex worker", val(r.CountMstClientIdMEClientsId3)],
          [...base, "High risk Migrants", val(r.CountMstClientIdMEClientsId4)],
          [...base, "IDU's", val(r.CountMstClientIdMEClientsId5)],
          [...base, "PLHIV", val(r.CountMstClientIdMEClientsId6)],
          [...base, "Transman", val(r.CountMstClientIdMEClientsId7)],
          [...base, "Transwoman", val(r.CountMstClientIdMEClientsId8)],
          [...base, "Transgender", val(r.CountMstClientIdMEClientsId9)],
          [...base, "Lesbian", val(r.CountMstClientIdMEClientsId10)],
          [...base, "Gay", val(r.CountMstClientIdMEClientsId11)],
          [...base, "Bisexual", val(r.CountMstClientIdMEClientsId12)],
          [...base, "Intersex", val(r.CountMstClientIdMEClientsId13)],
          [...base, "Closed settings", val(r.CountMstClientIdMEClientsId14)],
          [...base, "Vulnerable Woman", val(r.CountMstClientIdMEClientsId15)]
        );

        // Add the Total Marginalized and Excluded row (unique count from database)
        tableData.push([
          r.BranchName,
          r.SDP,
          r.Area,
          "Total Marginalized and Excluded",
          val(r.TotalClient),
        ]);
      });

      /* -------------------- SHEET DATA -------------------- */

      const wsData = [
        titleRow,
        dateRow,
        branchRow,
        spacingRow,
        headers,
        ...tableData,
      ];

      const ws = XLSX.utils.aoa_to_sheet(wsData);

      /* -------------------- HEADER STYLE -------------------- */

      headers.forEach((_, c) => {
        const cell = XLSX.utils.encode_cell({ r: 4, c });
        ws[cell].s = {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
          alignment: { horizontal: "center", vertical: "center" },
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
        };
      });

      /* -------------------- COLUMN WIDTHS -------------------- */

      ws["!cols"] = [
        { width: 20 },
        { width: 25 },
        { width: 30 },
        { width: 55 },
        { width: 15 },
      ];

      /* -------------------- BORDERS -------------------- */

      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const ref = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[ref]) continue;

          ws[ref].s = {
            ...ws[ref].s,
            border: {
              top: { style: "thin" },
              bottom: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
            },
          };
        }
      }

      /* -------------------- EXPORT -------------------- */

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Profile ME");
      XLSX.writeFile(wb, "Profile ME.xlsx");

      /* -------------------- SUCCESS LOG -------------------- */

      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "PROFILE ME EXPORT",
          action: "EXCEL EXPORT",
          status: "SUCCESS",
          tableName: null,
          description: `Profile ME export successful | Records exported: ${bindClientProfileMEData.length}`,
        },
        "Log/IUDLog"
      );
    } catch (error) {
      console.error(error);

      /* -------------------- ERROR LOG -------------------- */

      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "PROFILE ME EXPORT",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: null,
          description: error?.message || "Export failed",
        },
        "Log/IUDLog"
      );

      toast.error("Export failed", {
        position: "top-center",
        duration: 1500,
      });
    }
  };

  // const handleExport = async () => {
  //   const createdBy = sessionStorage.getItem("createdBy");

  //   /* -------------------- FILTER DATA -------------------- */

  //   const selectedOptionsData = {
  //     branchProjectData:
  //       branchProjectNamesList.length > 0
  //         ? branchProjectNamesList.toString()
  //         : branchName,
  //     sdpData: sdpNamesList.length > 0 ? sdpNamesList.toString() : "",
  //     areaData: areaNamesList.length > 0 ? areaNamesList.toString() : "",
  //   };

  //   try {
  //     /* -------------------- HEADERS -------------------- */

  //     const headers = [
  //       "Branch",
  //       "SDP",
  //       "Area",
  //       "Marginalized and Excluded",
  //       "Clients No.",
  //     ];

  //     /* -------------------- TOP ROWS -------------------- */

  //     const titleRow = ["Profile ME"];

  //     const dateRow = [
  //       "",
  //       "From Date:",
  //       formatDate(fromDate),
  //       "To Date:",
  //       formatDate(toDate),
  //     ];

  //     const branchRow = [
  //       "Branch/Project:",
  //       selectedOptionsData.branchProjectData,
  //       "",
  //       "S.D.P.: " + selectedOptionsData.sdpData,
  //       "Area: " + selectedOptionsData.areaData,
  //     ];

  //     const spacingRow = [""];

  //     /* -------------------- DATA -------------------- */

  //     const val = (v) => Number(v) || 0;
  //     const tableData = [];

  //     bindClientProfileMEData.forEach((r) => {
  //       const base = [r.BranchName, r.SDP, r.Area];

  //       tableData.push(
  //         [...base, "Person living with disability", val(r.CountMstClientIdMEClientsId1)],
  //         [...base, "Visual", val(r.CountMstClientIdDisability1)],
  //         [...base, "Locomotor", val(r.CountMstClientIdDisability2)],
  //         [...base, "Hearing", val(r.CountMstClientIdDisability3)],
  //         [...base, "Speech", val(r.CountMstClientIdDisability4)],
  //         [...base, "Intellectual", val(r.CountMstClientIdDisability5)],
  //         [...base, "Multiple disability", val(r.CountMstClientIdDisability6)],
  //         [...base, "Not applicable", val(r.CountMstClientIdDisability7)],
  //         [...base, "Person living with disability (Total exclusive)", val(r.CountMstClientIdMEClientsId1)],
  //         [...base, "BPL cardholder (Yes)", val(r.TotalClientBPLCardholder)],
  //         [...base, "SC,ST,DT,NT", val(r.CountMstClientIdMEClientsId2)],
  //         [...base, "Adolescent (10-19)", val(r.TotalClientAge10to19)],
  //         [...base, "Young population (15-24)", val(r.TotalClientAge15to24)],
  //         [...base, "Sex worker", val(r.CountMstClientIdMEClientsId3)],
  //         [...base, "High risk Migrants", val(r.CountMstClientIdMEClientsId4)],
  //         [...base, "IDU's", val(r.CountMstClientIdMEClientsId5)],
  //         [...base, "PLHIV", val(r.CountMstClientIdMEClientsId6)],
  //         [...base, "Transman", val(r.CountMstClientIdMEClientsId7)],
  //         [...base, "Transwoman", val(r.CountMstClientIdMEClientsId8)],
  //         [...base, "Transgender", val(r.CountMstClientIdMEClientsId9)],
  //         [...base, "Lesbian", val(r.CountMstClientIdMEClientsId10)],
  //         [...base, "Gay", val(r.CountMstClientIdMEClientsId11)],
  //         [...base, "Bisexual", val(r.CountMstClientIdMEClientsId12)],
  //         [...base, "Intersex", val(r.CountMstClientIdMEClientsId13)],
  //         [...base, "Closed settings", val(r.CountMstClientIdMEClientsId14)],
  //         [...base, "Vulnerable Woman", val(r.CountMstClientIdMEClientsId15)]
  //       );

  //       tableData.push([
  //         r.BranchName,
  //         r.SDP,
  //         r.Area,
  //         "Total Marginalized and Excluded",
  //         val(r.TotalClient),
  //       ]);
  //     });

  //     /* -------------------- GRAND TOTAL -------------------- */
  //     // Sum only the real per-branch ME totals from the source data,
  //     // NOT every flattened breakdown row (those overlap and double-count).

  //     // const grandTotal = tableData.reduce((sum, row) => {
  //     //   const clientsNo = Number(row[4]) || 0;
  //     //   return sum + clientsNo;
  //     // }, 0);

  //     // tableData.push([
  //     //   "Total",
  //     //   "Total",
  //     //   "",
  //     //   "",
  //     //   grandTotal,
  //     // ]);

  //     // tableData.push(["Total", "Total", "", "", grandTotal]);

  //     /* -------------------- SHEET DATA -------------------- */

  //     const wsData = [
  //       titleRow,
  //       dateRow,
  //       branchRow,
  //       spacingRow,
  //       headers,
  //       ...tableData,
  //     ];

  //     const ws = XLSX.utils.aoa_to_sheet(wsData);

  //     /* -------------------- HEADER STYLE -------------------- */

  //     headers.forEach((_, c) => {
  //       const cell = XLSX.utils.encode_cell({ r: 4, c });
  //       ws[cell].s = {
  //         font: { bold: true, color: { rgb: "FFFFFF" } },
  //         fill: { fgColor: { rgb: "2D2D6E" } },
  //         alignment: { horizontal: "center", vertical: "center" },
  //         border: {
  //           top: { style: "thin" },
  //           bottom: { style: "thin" },
  //           left: { style: "thin" },
  //           right: { style: "thin" },
  //         },
  //       };
  //     });

  //     /* -------------------- COLUMN WIDTHS -------------------- */

  //     ws["!cols"] = [
  //       { width: 20 },
  //       { width: 25 },
  //       { width: 30 },
  //       { width: 55 },
  //       { width: 15 },
  //     ];

  //     /* -------------------- BORDERS -------------------- */

  //     const range = XLSX.utils.decode_range(ws["!ref"]);
  //     for (let R = range.s.r; R <= range.e.r; R++) {
  //       for (let C = range.s.c; C <= range.e.c; C++) {
  //         const ref = XLSX.utils.encode_cell({ r: R, c: C });
  //         if (!ws[ref]) continue;

  //         ws[ref].s = {
  //           ...ws[ref].s,
  //           border: {
  //             top: { style: "thin" },
  //             bottom: { style: "thin" },
  //             left: { style: "thin" },
  //             right: { style: "thin" },
  //           },
  //         };
  //       }
  //     }

  //     /* -------------------- EXPORT -------------------- */

  //     const wb = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, "Profile ME");
  //     XLSX.writeFile(wb, "Profile ME.xlsx");

  //     /* -------------------- SUCCESS LOG -------------------- */

  //     await IUDAPI(
  //       {
  //         mstUserId: parseInt(createdBy, 10),
  //         sp: "PROFILE ME EXPORT",
  //         action: "EXCEL EXPORT",
  //         status: "SUCCESS",
  //         tableName: null,
  //         description: `Profile ME export successful | Records exported: ${bindClientProfileMEData.length}`,
  //       },
  //       "Log/IUDLog"
  //     );
  //   } catch (error) {
  //     console.error(error);

  //     /* -------------------- ERROR LOG -------------------- */

  //     await IUDAPI(
  //       {
  //         mstUserId: parseInt(createdBy, 10),
  //         sp: "PROFILE ME EXPORT",
  //         action: "EXCEL EXPORT",
  //         status: "FAILED",
  //         tableName: null,
  //         description: error?.message || "Export failed",
  //       },
  //       "Log/IUDLog"
  //     );

  //     toast.error("Export failed", {
  //       position: "top-center",
  //       duration: 1500,
  //     });
  //   }
  // };

  const downloadPDF = () => {
    const doc = new jsPDF("portrait"); // Use landscape orientation for more horizontal space
    const logoWidth = 30;
    const logoHeight = 14;
    doc.addImage(fpaiLogo, "JPEG", 10, 10, logoWidth, logoHeight);

    // Define your headers based on the format you want
    const headers = ["Branch", "Marginalized and Excluded", "Clients No."];

    // Prepare the data in the format compatible with autoTable
    const data = bindClientProfileMEData.flatMap((rowData, index) => {
      // Extracting the branch name (assuming you have it in your data)
      const branchName = rowData.BranchName || "Unknown Branch";
      return [
        ["Person living with disability", ""],
        ["Visual", rowData.CountMstClientIdDisability1.toString()],
        ["Locomotor", rowData.CountMstClientIdDisability2.toString()],
        ["Hearing", rowData.CountMstClientIdDisability3.toString()],
        ["Speech", rowData.CountMstClientIdDisability4.toString()],
        ["Intellectual", rowData.CountMstClientIdDisability5.toString()],
        ["Multiple disability", rowData.CountMstClientIdDisability6.toString()],
        ["Not applicable", rowData.CountMstClientIdDisability7.toString()],
        [
          "Person living with disability (Total exclusive)",
          rowData.CountMstClientIdMEClientsId1.toString(),
        ],
        ["BPL cardholder (Yes)", rowData.TotalClientBPLCardholder.toString()],
        ["SC,ST,DT,NT", rowData.CountMstClientIdMEClientsId2.toString()],
        ["Adolescent (10-19)", rowData.TotalClientAge10to19.toString()],
        ["Young population (15-24)", rowData.TotalClientAge15to24.toString()],
        ["Sex worker", rowData.CountMstClientIdMEClientsId3.toString()],
        ["High risk Migrants", rowData.CountMstClientIdMEClientsId4.toString()],
        ["IDU's", rowData.CountMstClientIdMEClientsId5.toString()],
        ["PLHIV", rowData.CountMstClientIdMEClientsId6.toString()],
        ["Transman", rowData.CountMstClientIdMEClientsId7.toString()],
        ["Transwoman", rowData.CountMstClientIdMEClientsId8.toString()],
        ["Transgender", rowData.CountMstClientIdMEClientsId9.toString()],
        ["Lesbian", rowData.CountMstClientIdMEClientsId10.toString()],
        ["Gay", rowData.CountMstClientIdMEClientsId11.toString()],
        ["Bisexual", rowData.CountMstClientIdMEClientsId12.toString()],
        ["Intersex", rowData.CountMstClientIdMEClientsId13.toString()],
        ["Closed settings", rowData.CountMstClientIdMEClientsId14.toString()],
        ["Vulnerable Woman", rowData.CountMstClientIdMEClientsId15.toString()],
        ["Total Marginalized and Excluded", rowData.TotalClient.toString()],
      ].map((item) => [branchName, ...item]);
    });

    // Create the table with headers and data
    doc.autoTable({
      head: [headers],
      body: data,
      startY: 30,
      styles: {
        fontSize: 10, // Reduced font size
        lineColor: "black",
        lineWidth: 0.2,
        halign: "left", // Align text to left
        valign: "middle", // Align text vertically in the middle
        cellPadding: 2, // Add padding to cells
      },
      headStyles: {
        fillColor: "#2d2d6e",
        textColor: [255, 255, 255],
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // Light gray color for alternate rows
      },
    });

    doc.save("Profile ME.pdf");
  };

  const BranchProjectFetchData = async () => {
    try {
      const userProfileDatas = userProfileState.userProfile;
      const [profile] = userProfileDatas;
      const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
        languageCode: "en",
      };

      const locationResponse = await BindPostAPI([data], "LocationAPI/BindLocation");


      const locationData = locationResponse.data.Table.map((item) => ({
        value: item.MstLocationId,
        label: item.LocationName_en,
      }));

      setBindBranchProjectDD(locationData);
    } catch (error) { }
  };

  const sdpChange = (updatedOptions) => {
    setArea("");
    setShowTable(false);
    setSDP(updatedOptions);
    setBindAreaDD([]);
    const SDPlabels = getSDPNames(updatedOptions);
    setSDPNamesList(SDPlabels);
  };

  const getSDPNames = (updatedOptions) => {
    const NameList = updatedOptions
      .map((option) => bindSDP?.find((item) => item.value === option)?.label)
      .filter(Boolean); // Remove undefined values if any

    return NameList;
  };

  const brangeChange = (updatedOptions) => {
    setSDP("");
    setArea("");
    setShowTable(false);
    setBindSDP([]);
    setBindAreaDD([]);
    setBranchProject(updatedOptions);
    const branchProjectlabels = getBranchProjectsNames(updatedOptions);
    setBranchProjectNamesList(branchProjectlabels);
  };

  const getBranchProjectsNames = (updatedOptions) => {
    const NameList = updatedOptions
      .map(
        (option) =>
          bindBranchProjectDD?.find((item) => item.value === option)?.label
      )
      .filter(Boolean); // Remove undefined values if any

    return NameList;
  };

  const areaChange = (updatedOptions) => {
    setArea("");
    setShowTable(false);
    setArea(updatedOptions);
    const arealabels = getAreaNames(updatedOptions);
    setAreaNamesList(arealabels);
  };

  const getAreaNames = (updatedOptions) => {
    const NameList = updatedOptions
      .map((option) => bindArea?.find((item) => item.value === option)?.label)
      .filter(Boolean); // Remove undefined values if any

    return NameList;
  };

  return (
    <MainLayout pageName="4">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />

      <div>
        <div class="relative m-3 bg-white rounded-lg ">
          <div class="mt-3 py-4">
            <div className={mainTable.headerTitle}>
              <div className="my-2 mx-12 lg:mx-0">{`Profile ME`}</div>
            </div>
            <div className={mainTable.grid3}>
              {userProfileDatas[0]?.MstOrganizationId == 1 && (
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Branch/Project"
                    filteredOptions={bindBranchProjectDD}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      branchProject?.length > 0 ? "More Selected" : "Select..."
                    }
                    name="branchProject"
                    selectedOptions={branchProject}
                    classDiv="relative w-full inline-block"
                    onChange={brangeChange}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {branchProjectError && (
                    <span className="text-red-500">{branchProjectError}</span>
                  )}
                </div>
              )}
              {(userProfileDatas[0]?.MstOrganizationId == 2 ||
                userProfileDatas[0]?.MstOrganizationId == 3) && (
                  <InputText
                    inputType="text"
                    title="Branch/Project"
                    classStar="text-red-500"
                    name="schoolName"
                    disabled="true"
                    content={branchName}
                    controlFunc={(e) => setBranchName(e.target.value)}
                  />
                )}
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="SDP"
                  filteredOptions={bindSDP}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={sdp?.length > 0 ? "More Selected" : "Select..."}
                  name="sdp"
                  selectedOptions={sdp}
                  classDiv="relative w-full inline-block"
                  onChange={sdpChange}
                  classLabel={mainTable.labelNoWrap}
                />
                {sdpError && <span className="text-red-500">{sdpError}</span>}
              </div>

              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Area"
                  filteredOptions={bindArea}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={area?.length > 0 ? "More Selected" : "Select..."}
                  name="area"
                  selectedOptions={area}
                  classDiv="relative w-full inline-block"
                  onChange={areaChange}
                  classLabel={mainTable.labelNoWrap}
                />
                {areaError && <span className="text-red-500">{areaError}</span>}
              </div>
            </div>
            <div class={mainTable.grid3}>
              <InputText
                inputType="date"
                title="From"
                name="fromDate"
                content={fromDate}
                controlFunc={(e) => { setFromDate(e.target.value); setShowTable(false); }}
              />
              <InputText
                inputType="date"
                title="To"
                name="toDate"
                content={toDate}
                controlFunc={(e) => { setToDate(e.target.value); setShowTable(false); }}
              />
              <div class="flex justify-start items-center mt-6">
                <button
                  type="button"
                  onClick={() => GoButton()}
                  className={mainTable.addButton}
                >
                  GO
                </button>
              </div>
            </div>
          </div>
        </div>
        {showTable &&
          (bindClientProfileMEData.length > 0 ? (
            <div>
              <ReportRowRowPage
                title=""
                header={ClientProfileMEReportHeader}
                records={bindClientProfileMEData}
                handleExport={handleExport}
                handlePDF={downloadPDF}
                isGenderBased={true}
              />
            </div>
          ) : (
            <div className="flex items-center justify-center">
              No record found
            </div>
          ))}
      </div>
    </MainLayout>
  );
};

export default ClientProfileMEReport;
